export enum EYesNo {
    Yes = '1',
    No = '0',
    NeedMoreInfo = '2',
}

export enum ETrueFalse {
    true = 1,
    false = 0,
}

export enum ERate {
    Good = '1',
    Poor = '0',
    Fair = '2',
}

export enum EStatus {
    FormUndone = 0, // form hasn't been completed
    FormDone = 1, // form has been completed but review hasn't been requested
    ReviewPending = 2, // review has been requested and waiting for review
    ReviewComplete = 3, // review has been completed
}

export enum EStage {
    Evaluations = 1,
    Assessments = 2,
    Plans = 3,
    Interventions = 4,
    Monitoring = 5,
    Closed = 6
}

export enum EFormSection {
    AssessScreen = 1,
    FullTeamAssessment = 2,
    TeacherStaffInterview = 3,
    WitnessInterview = 4,
    StudentInterview = 5,
    ParentInterview = 6,
    
}